if (!customElements.get('gift-box-list')) {
  class GiftBoxList extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onRadioChange.bind(this));
    }

    // Instant visual feedback for the selected card border,
    // ahead of Dawn's own section re-render finishing.
    onRadioChange(event) {
      const radio = event.target.closest('.gift-box-list__radio');
      if (!radio) return;

      this.querySelectorAll('.gift-box-list__item--selected').forEach((item) => {
        item.classList.remove('gift-box-list__item--selected');
      });

      const selectedItem = radio.closest('.gift-box-list__item');
      if (selectedItem) {
        selectedItem.classList.add('gift-box-list__item--selected');
      }
    }
  }

  customElements.define('gift-box-list', GiftBoxList);
}